module.exports = __webpack_public_path__ + "img/icon_landing2.8351706f.jpeg";